// assets/auto-bonus-download.js
(() => {
  // ✅ SET THIS
  const BONUS_VARIANT_ID = 44410737426501;

  // Optional: if you *don't* want the bonus to trigger for carts containing ONLY the bonus,
  // we also auto-remove it when it's the only item.
  const BONUS_QTY = 1;

  const isCartEndpoint = (url) =>
    typeof url === "string" &&
    (url.includes("/cart/add") || url.includes("/cart/change") || url.includes("/cart/update") || url.includes("/cart/clear"));

  async function getCart() {
    const res = await fetch("/cart.js", { credentials: "same-origin" });
    if (!res.ok) throw new Error("Failed to fetch cart");
    return res.json();
  }

  async function addBonus() {
    await fetch("/cart/add.js", {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: [{ id: BONUS_VARIANT_ID, quantity: BONUS_QTY }] }),
    });
  }

  async function setLineQty(key, quantity) {
    await fetch("/cart/change.js", {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: key, quantity }),
    });
  }

  async function ensureBonusInCart() {
    let cart;
    try {
      cart = await getCart();
    } catch (e) {
      return;
    }

    const items = cart.items || [];
    const bonusLine = items.find((i) => Number(i.variant_id) === Number(BONUS_VARIANT_ID));
    const nonBonusCount = items.reduce((sum, i) => {
      return sum + (Number(i.variant_id) === Number(BONUS_VARIANT_ID) ? 0 : Number(i.quantity || 0));
    }, 0);

    // If cart has real items, ensure bonus exists (qty = 1)
    if (nonBonusCount > 0) {
      if (!bonusLine) {
        try {
          await addBonus();
        } catch (e) {
          // ignore
        }
        return;
      }
      if (bonusLine.quantity !== BONUS_QTY) {
        try {
          await setLineQty(bonusLine.key, BONUS_QTY);
        } catch (e) {
          // ignore
        }
      }
      return;
    }

    // If cart has no real items, remove bonus if it's there
    if (nonBonusCount === 0 && bonusLine) {
      try {
        await setLineQty(bonusLine.key, 0);
      } catch (e) {
        // ignore
      }
    }
  }

  // Run once on page load (won't add anything if cart is empty)
  document.addEventListener("DOMContentLoaded", () => {
    ensureBonusInCart();
  });

  // Intercept AJAX cart changes so it re-checks after add/remove
  const _fetch = window.fetch;
  window.fetch = async (...args) => {
    const res = await _fetch(...args);

    try {
      const url = args?.[0];
      if (isCartEndpoint(url)) {
        // let Shopify update UI first, then ensure
        setTimeout(() => ensureBonusInCart(), 150);
      }
    } catch (_) {}

    return res;
  };
})();
